export default /* @ngInject */ function taxlabel() {
    const taxLables = {
        vat: 'VAT',
        sales: 'Sales Tax',
        vat_reversed: 'VAT Reversed'
    };
    return function (tax) {
        return taxLables[tax];
    };
}



// WEBPACK FOOTER //
// ./payments/review/filters/taxlabel.js